import type { ShortcutHandlerContext } from '../../../../../lib/types.js';
import { handleShortcutCodeNav } from '../../../../../lib/code-nav/handle-code-nav.js';

/** GET /api/sessions/:sessionId/files/code-nav */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  await handleShortcutCodeNav(ctx, ctx.params.sessionId);
}
